import { render } from "./TableBills.vue?vue&type=template&id=67d5a9d8&scoped=true"
import script from "./TableBills.vue?vue&type=script&lang=js"
export * from "./TableBills.vue?vue&type=script&lang=js"

import "./TableBills.vue?vue&type=style&index=0&id=67d5a9d8&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d5a9d8"]])

export default __exports__